import * as o from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/ArrowUUpRight.es.js";
const r = o.forwardRef((t, e) => /* @__PURE__ */ o.createElement(a, { ref: e, ...t, weights: i }));
r.displayName = "ArrowUUpRightIcon";
const c = r;
export {
  c as ArrowUUpRight,
  r as ArrowUUpRightIcon
};
